<template>
  <v-card outlined class="mb-4">
    <v-card-text class="py-2 d-flex align-center flex-wrap">
      <span class="text-body-2 mr-3">Editing:</span>
      <v-btn-toggle v-model="ctx" mandatory dense>
        <v-btn small value="main">Report page</v-btn>
        <v-btn v-for="d in drilldowns" :key="d.id" small :value="d.id">
          <v-icon left x-small>mdi-table-search</v-icon>{{ d.name || d.id }}
        </v-btn>
      </v-btn-toggle>
      <v-spacer />
      <span class="text-caption grey--text">
        {{ ctx === 'main' ? 'What people see when they open the report.' : 'The underlying-data view that opens in its own tab. Manage these in the Underlying data tab.' }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import { state } from './editorState'

export default {
  name: 'RbContextBar',
  computed: {
    drilldowns () { return (state.tpl && state.tpl.drilldowns) || [] },
    ctx: {
      get () { return state.ctx },
      set (v) { state.ctx = v }
    }
  }
}
</script>
